import { jsxs as r, Fragment as m, jsx as e } from "react/jsx-runtime";
import { useState as c } from "react";
import { classes as o } from "../../utils/helpers.js";
import { NavList as b } from "../NavList/NavList.js";
import { LogoNavigation as k } from "../LogoNavigation/LogoNavigation.js";
import { ImageReplacementAnchor as N } from "../ImageReplacementAnchor/ImageReplacementAnchor.js";
import { Overlay as x } from "../Overlay/Overlay.js";
import '../../assets/DrawerNavigation.css';const A = "_clipPathOpen_5hknh_1", O = "_clipPathClose_5hknh_1", n = {
  "drawer-navigation__nav-bar": "_drawer-navigation__nav-bar_5hknh_1",
  "with-logo": "_with-logo_5hknh_11",
  "drawer-navigation__menu-toggle": "_drawer-navigation__menu-toggle_5hknh_15",
  "drawer-navigation__hamburger": "_drawer-navigation__hamburger_5hknh_22",
  "drawer-navigation__primary-navigation": "_drawer-navigation__primary-navigation_5hknh_54",
  clipPathOpen: A,
  clipPathClose: O,
  "drawer-navigation__separator": "_drawer-navigation__separator_5hknh_102",
  "visually-hidden": "_visually-hidden_5hknh_113"
};
function I({
  links: d = [],
  items: s = [],
  classname: v = "",
  logo: i = {},
  clipPathStart: p = "circle(0% at top right)",
  clipPathEnd: u = "circle(250% at top right)",
  overlayAppendEl: w = document.querySelector("#root")
}) {
  const [a, y] = c(!1), [_, l] = c(null), g = document.querySelector("body"), h = () => {
    if (y(!a), l("closing"), a) {
      const t = document.querySelector("#overlay");
      t == null || t.setAttribute("data-state", "exiting"), setTimeout(() => {
        t == null || t.remove(), g.style.overflowY = "auto";
      }, 400);
    } else
      g.style.overflowY = "hidden";
  }, f = () => {
    a || l(null);
  };
  return document.addEventListener("scripps:overlay:closed", h), // Ideally the parent for this component will be a <nav> for accessibility reasons
  /* @__PURE__ */ r(m, { children: [
    /* @__PURE__ */ r(
      "div",
      {
        className: o([
          n["drawer-navigation__nav-bar"],
          "drawer-navigation__nav-bar",
          i.image && n["with-logo"],
          `drawer-navigation__nav-bar--${a ? "expanded" : _ ? "closing" : "closed"}`
        ]),
        children: [
          i.image && /* @__PURE__ */ e(
            N,
            {
              href: i.href,
              image: i.image,
              height: i.height,
              baselineAdjustment: i.baselineAdjustment
            }
          ),
          /* @__PURE__ */ r(
            "button",
            {
              className: o([
                n["drawer-navigation__menu-toggle"],
                "drawer-navigation__menu-toggle"
              ]),
              "aria-controls": "drawer-navigation__primary-navigation",
              "aria-expanded": a,
              onClick: h,
              children: [
                /* @__PURE__ */ e("span", { className: n["visually-hidden"], children: "Menu" }),
                /* @__PURE__ */ e(
                  "div",
                  {
                    className: o([
                      n["drawer-navigation__hamburger"],
                      "drawer-navigation__hamburger"
                    ]),
                    "aria-hidden": "true"
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r(
      "div",
      {
        className: o([
          n["drawer-navigation__primary-navigation"],
          "drawer-navigation__primary-navigation"
        ]),
        id: "drawer-navigation__primary-navigation",
        "data-state": a ? "opened" : _ || "closed",
        onAnimationEnd: f,
        style: {
          "--clip-path-start": p,
          "--clip-path-end": u
        },
        children: [
          d.length > 0 && /* @__PURE__ */ e(b, { links: d, classname: v }),
          s.length > 0 && /* @__PURE__ */ r(m, { children: [
            /* @__PURE__ */ e(
              "hr",
              {
                className: o([
                  n["drawer-navigation__separator"],
                  "drawer-navigation__separator"
                ])
              }
            ),
            /* @__PURE__ */ e(k, { items: s })
          ] })
        ]
      }
    ),
    a && /* @__PURE__ */ e(x, { appendToElement: w, state: _ === null && !a ? "exiting" : "entering" })
  ] });
}
export {
  I as DrawerNavigation,
  I as default
};
